import { h } from '@stencil/core';
import { ElementToggler } from "../../utils";
class ExpandableItem {
  constructor() {
    this.id = ++ExpandableItem.ID_COUNTER;
    this.onHeaderClick = e => this.toggle(e);
    this.toggler = new ElementToggler('.expandable-item-body');
    this.header = undefined;
    this.isOpen = undefined;
  }
  async close() {
    if (this.isOpen) {
      this.doClose();
    }
  }
  async open() {
    if (!this.isOpen) {
      this.doOpen();
    }
  }
  toggle(e) {
    e.preventDefault();
    this.isOpen ? this.doClose() : this.doOpen();
    this.expandableOpened.emit(this.isOpen);
  }
  doClose() {
    this.isOpen = false;
    this.toggler.hide(this.el.shadowRoot);
  }
  doOpen() {
    this.isOpen = true;
    this.toggler.show(this.el.shadowRoot);
  }
  render() {
    return (h("li", { class: {
        'expandable-item': true,
        'expandable-item-open': this.isOpen,
      } }, h("button", { class: "expandable-item-header", id: `expandable-item-header-${this.id}`, "aria-controls": `expandable-item-body-${this.id}`, "aria-expanded": this.isOpen ? 'true' : 'false', onClick: this.onHeaderClick }, h("oebbx-icon", { name: "triangle", svgStyle: null }), h("slot", { name: "header-icon" }), h("slot", { name: "header" }), h("span", null, this.header)), h("div", { class: "expandable-item-body", id: `expandable-item-body-${this.id}`, "aria-labelledby": `expandable-item-header-${this.id}`, "aria-expanded": this.isOpen ? 'true' : 'false', role: "region" }, h("div", { class: "expandable-item-content" }, h("slot", null)))));
  }
  static get is() { return "oebbx-expandable-item"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["expandable-item.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["expandable-item.css"]
    };
  }
  static get properties() {
    return {
      "header": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "header",
        "reflect": false
      },
      "isOpen": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-open",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "expandableOpened",
        "name": "expandableOpened",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        }
      }];
  }
  static get methods() {
    return {
      "close": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      },
      "open": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      }
    };
  }
  static get elementRef() { return "el"; }
  static get stencilHasStaticMembersWithInit() { return true; }
}
ExpandableItem.ID_COUNTER = 0;
export { ExpandableItem };
//# sourceMappingURL=expandable-item.js.map
